<template>
    <div class="feature" :class="[hasAction ? 'has-action' : '', inPageBottom ? 'in-page-bottom' : 'in-page-left', removeMarginRight ? 'remove-margin' : '']">        
        <RoundIcon :icon="icon" />
        <svg class='arrow' v-if="hasAction" width="18" height="20" viewBox="0 0 9 10" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="a">
                <stop stop-color="#FFF" offset="0%"/>
                <stop stop-color="#B3B1B1" offset="100%"/>
                </linearGradient>
            </defs>
            <path d="M1045.358 321.198v-3.247h3.264v-1.887h-3.264v-3.23h-1.938v3.23h-3.264v1.887h3.264v3.247z" transform="translate(-1040 -312)" fill="url(#a)" fill-rule="nonzero"/>
        </svg>
        <div class="label" :class="[yellowLabel ? 'yellow' : '']">
            <span v-html="label"></span>
            <transition appear name="grow" >
                <span class="bar"></span>
            </transition>
        </div>
        <div class="description" :class="[limitWidth ? 'limit-width' : '']" v-html="description"></div>
    </div>
</template>

<script>
import RoundIcon from "@/patterns/RoundIcon.vue";
export default {
  name: "Feature",  
  components: { RoundIcon },
  data: () => ({}),
  props: { label: String, description:String, icon:String, limitWidth:Boolean, yellowLabel:Boolean, inPageBottom:Boolean, removeMarginRight:Boolean, hasAction:Boolean },
};
</script>


<style lang="scss" scoped>
.arrow {
    display: inline-block;
    position: absolute;
    left: 60px;
    top: 15px;
}
.feature {
    display:inline-block;    
    white-space: nowrap;
    margin-right:50px;    
    vertical-align: top;
    &.in-page-bottom {
        width:auto;
        margin-bottom:30px;
    }
    &.in-page-left {
        width:165px;
        margin-bottom:30px;
    }
    &.has-action {
        user-select: none;
        cursor: pointer;
        position: relative;
        .label {
            transition: color 0.25s cubic-bezier(1, 0.5, 0.8, 1);
        }
        &:hover .label {
            color:#f5831f;    
        }
    }
    &.remove-margin {
        margin-right: 0;
    }
    &:last-child {
        margin-right: 0;
    }
}
.label {
    color: #FFFFFF;
    font-family: 'Gotham';
    font-size: 0.9em;
    font-weight: 900;
    letter-spacing: 0;    
    position: relative;
    text-transform: uppercase;
    margin-top:15px;
    margin-bottom: 15px;        
    padding-bottom:10px;
    white-space: normal;
    .bar {
        position: absolute;
        bottom:-3px;
        left:0;
        display: inline-block;
        transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
        height: 2px;
        width: 75px;
        background: linear-gradient(90deg, #F5831F 0%, #FFD62F 100%);
        &.grow-enter-to,
        &.grow-enter-active {
            width: 0;
        }
    }
    span {
        font-weight: 900;
    }
}
.description {    
    color: #FFFFFF;
    font-family: 'Gotham';
    font-size: 0.9em;
    
    letter-spacing: 0;
    white-space: normal;
    &.limit-width {
        width:115px;
    }
}
</style>
